import React, { Component } from 'react';
import {Link} from 'react-router-dom'
class Slider extends Component {
    render() {
        return (
            <div id="rev_slider_1078_1_wrapper" className="rev_slider_wrapper fullwidthbanner-container" data-alias="classic4export" data-source="gallery">
            
            <div id="rev_slider_1078_1" className="rev_slider fullwidthabanner"  data-version="5.3.0.2">
                <ul>
                    {/* <!-- SLIDE 1 --> */}
                    <li data-index="rs-3047" data-transition="slideremovedown" data-slotamount="7" data-hideafterloop="0" data-hideslideonmobile="off"  data-easein="Power4.easeInOut" data-easeout="Power4.easeInOut" data-masterspeed="2000"  data-thumb="assets/images/bike-100x50.jpg"  data-rotate="0"  data-saveperformance="off"  data-title="Ken Burns" data-param1="" data-param2="" data-param3="" data-param4="" data-param5="" data-param6="" data-param7="" data-param8="" data-param9="" data-param10="" data-description="">

                        {/* <!-- MAIN IMAGE --> */}
                        <img src="images/slides/1.jpg"  alt=""  data-bgposition="center center" data-kenburns="off" data-duration="30000" data-ease="Linear.easeNone" data-scalestart="100" data-scaleend="120" data-rotatestart="0" data-rotateend="0" data-offsetstart="0 0" data-offsetend="0 0" data-bgparallax="10" className="rev-slidebg" data-no-retina />
                        {/* <!-- LAYERS --> */}

                        {/* <!-- LAYER NR. 12 --> */}
                        <div className="tp-caption title-slide" 
                            id="slide-3047-layer-1" 
                            data-x="['center','center','center','center']" data-hoffset="['-208','-100','0','0']" 
                            data-y="['middle','middle','middle','middle']" data-voffset="['-70','-70','-70','-60']" 
                            data-fontsize="['65','65','45','30']"
                            data-lineheight="['65','65','45','35']"
                            data-fontweight="['700','700','700','700']"
                            data-width="none"
                            data-height="none"
                            data-whitespace="nowrap"
                 
                            data-type="text" 
                            data-responsive_offset="on"                             

                            data-frames='[{"delay":1000,"speed":2000,"frame":"0","from":"y:-50px;opacity:0;","to":"o:1;","ease":"Power3.easeInOut"},{"delay":"wait","speed":300,"frame":"999","to":"auto:auto;","ease":"Power3.easeInOut"}]'

                            data-textalign="['left','left','center','center']"
                            data-paddingtop="[10,10,10,10]"
                            data-paddingright="[0,0,0,0]"
                            data-paddingbottom="[0,0,0,0"
                            data-paddingleft="[0,0,0,0]"

                            >Top 20 sales <br />Training company
                        </div>

                        {/* <!-- LAYER NR. 13 --> */}
                        <div className="tp-caption sub-title" 
                            id="slide-3047-layer-4" 
                            data-x="['center','center','center','center']" data-hoffset="['-220','-120','0','0']" 
                            data-y="['middle','middle','middle','middle']" data-voffset="['29','29','29','0']"
                            data-fontsize="['16',16','16','14']" 
                            data-fontweight="['600','600','600','600']"
                            data-width="660"
                            data-height="none"
                            data-whitespace="nowrap"
                 
                            data-type="text" 
                            data-responsive_offset="on" 

                            data-frames='[{"from":"y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;","mask":"x:0px;y:[100%];s:inherit;e:inherit;","speed":2000,"to":"o:1;","delay":1500,"ease":"Power4.easeInOut"},{"delay":"wait","speed":1000,"to":"y:[100%];","mask":"x:inherit;y:inherit;s:inherit;e:inherit;","ease":"Power2.easeInOut"}]'
                            data-textalign="['left','left','center','center']"
                            data-paddingtop="[0,0,0,0]"
                            data-paddingright="[0,0,0,0]"
                            data-paddingbottom="[0,0,0,0]"
                            data-paddingleft="[0,0,0,0]"

                            >We serve every size and type company from startups to Fortune 50.
                        </div>

                        <Link to="/overview" onClick={() => {window.location.href="/overview"}} target="_self" className="tp-caption flat-button-slider bg-orange"         

                        data-frames='[{"from":"y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;","mask":"x:0px;y:[100%];s:inherit;e:inherit;","speed":2000,"to":"o:1;","delay":2000,"ease":"Power4.easeInOut"},{"delay":"wait","speed":1000,"to":"y:[100%];","mask":"x:inherit;y:inherit;s:inherit;e:inherit;","ease":"Power2.easeInOut"}]'
                     
                        data-x="['center','center','center','center']" data-hoffset="['-453','-353','0','0']" 
                        data-y="['middle','middle','middle','middle']" data-voffset="['134','134','134','50']"  
                        // data-hoffset="-75" 
                        // data-voffset="83" 
                        data-width="['210']"
                        data-height="['55']">OUR COMPANY <i className="fa fa-chevron-right"></i>
                        </Link>
                        {/* <!-- END LAYER LINK --> */}
                    </li>

                    {/* <!-- SLIDE 2 --> */}
                    <li data-index="rs-3048" data-transition="slideremoveright" data-slotamount="default" data-hideafterloop="0" data-hideslideonmobile="off"  data-easein="Power4.easeInOut" data-easeout="Power4.easeInOut" data-masterspeed="2000"  data-thumb="assets/images/fitness-100x50.jpg"  data-rotate="0"  data-saveperformance="off"  data-title="HTML5 Video" data-param1="" data-param2="" data-param3="" data-param4="" data-param5="" data-param6="" data-param7="" data-param8="" data-param9="" data-param10="" data-description="">
                        {/* <!-- MAIN IMAGE --> */}
                        <img src="images/slides/2.png"  alt=""  data-bgposition="center center" data-bgfit="cover" data-bgparallax="10" className="rev-slidebg" data-no-retina />
                        
                        {/* <!-- BACKGROUND VIDEO LAYER --> */}
                        <div className="rs-background-video-layer" 
                            data-forcerewind="on" 
                            data-volume="mute" 
                            data-vimeoid="82642494" 
                            data-videoattributes="background=1&title=0&amp;byline=0&amp;portrait=0&amp;api=1" 
                            data-videowidth="100%" 
                            data-videoheight="100%" 
                            data-videocontrols="none" 
                            data-videostartat="00:00" 
                            data-videoendat="00:48" 
                            data-videoloop="loop" 
                            data-forcecover="1" 
                            data-aspectratio="4:3" 
                            data-autoplay="true" 
                            data-autoplayonlyfirsttime="false" ></div>


                        {/* <!-- LAYER NR. 12 --> */}
                        <div className="tp-caption title-slide-style2" 
                            id="slide-3047-layer-1" 
                            data-x="['center','center','center','center']" data-hoffset="['0','0','0','0']" 
                            data-y="['middle','middle','middle','middle']" data-voffset="['-57','-57','-57','-50']" 
                            data-fontsize="['50','50','35','20']"
                            data-lineheight="['68','68','40','22']"
                            data-width="none"
                            data-fontweight="700"
                            data-color="#fff"
                            data-height="none"
                            data-whitespace="nowrap"
                 
                            data-type="text" 
                            data-responsive_offset="on"                      

                            data-frames='[{"delay":1000,"speed":2000,"frame":"0","from":"z:0;rX:0deg;rY:0;rZ:0;sX:2;sY:2;skX:0;skY:0;opacity:0;","mask":"x:0px;y:0px;s:inherit;e:inherit;","to":"o:1;","ease":"Power2.easeOut"},{"delay":"wait","speed":300,"frame":"999","to":"auto:auto;","ease":"Power3.easeInOut"}]'

                            data-textalign="['center','center','center','center']"
                            data-paddingtop="[10,10,10,10]"
                            data-paddingright="[0,0,0,0]"
                            data-paddingbottom="[10,10,10,10]"
                            data-paddingleft="[0,0,0,0]"

                            >Helping organizations innovate,<br />transform, and lead</div>
                    </li> 
                </ul>
            </div>
        </div>
       
        );
    }
}

export default Slider;